import { KepLoginStep } from "@/components/login/KepLoginStep"

export function Login() {
  return <KepLoginStep />
}
